<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant.sync="miniValue"
    permanent
    fixed
    dark
    width="300"
    app
  >
    <v-app-bar
      v-if="navbarLogo"
      :dense="toolbarDense"
      dark
      class="logo-nav"
      @click.stop.prevent=""
    >
      <v-toolbar-title class="text-center">
        <v-avatar tile class="company-logo-mini" v-if="miniValue">
          <img
            src="../../assets/NYC-N-NEW.jpg"
            alt="nyc-short-logo"
            @click="navigateHome"
          />
        </v-avatar>
        <v-avatar tile class="company-logo" v-else>
          <v-row no-gutters>
            <v-col cols="12" class="column mt-6">
              <img
                src="../../assets/nyc-white.png"
                alt="nyc-logo"
                @click="navigateHome"
              />
            </v-col>
            <!-- <v-col cols="12" class="column">
              <div class="pro-serv-heading ml-10">NYC Portal</div>
            </v-col> -->
          </v-row>
        </v-avatar>
      </v-toolbar-title>
    </v-app-bar>
    <the-layout-drawer-list
      :mini="miniValue"
      :dense="navbarDense"
      :routes="routesPath"
      icon-show
    />
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import TheLayoutDrawerList from "./TheLayoutDrawerList.vue";
import { adminRoutes } from "../../config/admin.route.config";
//import  { constantRoutes } from '@/router';

const hasPermission = (role, route) => {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.includes(role);
  }
  return true;
};

const filterAsyncRoutes = (roles, routes) => {
  const res = [];
  routes.forEach(route => {
    const tmp = { ...route };
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(roles, tmp.children);
      }
      res.push(tmp);
    }
  });
  return res;
};
export default {
  name: "TheLayoutDrawer",
  props: {
    miniValue: { type: Boolean, default: true }
  },
  components: {
    TheLayoutDrawerList
  },
  data: () => ({
    routesPath: [],
    color: "dark",
    drawer: true,
    mini: true
  }),
  watch: {
    miniValue() {
      this.$emit("mini", this.miniValue);
    }
  },
  computed: {
    ...mapGetters([
      "navbarDense",
      "navbarShow",
      "navbarLogo",
      "toolbarDense",
      "roles"
    ])
  },
  created() {
    this.routesPath = filterAsyncRoutes(this.roles, adminRoutes);
    // switch(this.roles) {
    //   case 'Admin':
    //     this.routesPath = adminRoutes;
    //     break;
    //   case 'Install Manager':
    //     this.routesPath = adminRoutes;
    //     break;
    //   case 'Sales':
    //     this.routesPath = installAdminRoutes
    // }
  },
  mounted() {},
  methods: {
    stateNavbarShow(state) {
      this.$store.dispatch("NavbarState", { state });
    },
    navigateHome() {
      this.$router.push("/");
    }
  }
};
</script>
<style scoped lang="scss">
@import "../../assets/styles/variables.scss";
.v-list-item__title {
  font-family: "Segoe UI", "Roboto", sans-serif;
  font-weight: 400 !important;
  font-size: 16px !important;
}
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 16px;
}
.theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  margin-left: 4px;
  height: 52px;
  padding: 16px 32px;
  display: flex;
  align-items: center;
}
.mdi {
  font-size: 35px !important;
}
a.v-list-item--active.v-list-item.v-list-item--link.theme--dark {
  height: 52px;
  padding: 16px 32px;
  display: flex;
  align-items: center;
}
.v-application--is-ltr .v-list-item__icon:first-child {
  margin: 0;
  margin-right: 16px;
}
.v-list--dense .v-list-item .v-list-item__content {
  padding: 0;
  padding-top: 5px;
}
.navigation-icon {
  color: #fff !important;
}
.company-logo-mini {
  width: 48px !important;
  height: 48px !important;
}
.company-logo-mini img {
  width: 29.19px;
  height: 32px;
  cursor: pointer;
}
.company-logo img {
  height: 32px;
  width: auto;
  cursor: pointer;
}

.v-toolbar__content {
  text-align: center;
}
.v-toolbar__title {
  width: 100%;
}

.company-logo .column {
  width: 100% !important;
}
.pro-serv-heading {
  font-size: 14px;
  color: #f7402f;
  font-weight: 500;
  margin-top: -10px;
}
</style>
